import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Screenshots from './components/Screenshots';
import Coming from './components/Coming';
import Signup from './components/Signup';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="app">
      <Hero />
      <main>
        <About />
        <Screenshots />
        <Coming />
        <Signup />
      </main>
      <Footer />
    </div>
  );
}

export default App;
